export default async function fetchAdToken() {
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || 'https://safacards.onrender.com'}/api/get-ad-token`);
    const { token } = await res.json();
    window.userAdToken = token;
  } catch (err) {
    console.error("Failed to fetch AdSense token:", err);
  }
}
